import { ColumnFilter, ColumnSort } from '@tanstack/react-table';
import axiosInstance from 'config/axios';
import { PaginationResponse } from 'interfaces/pagination-response';

/**
 * @description Drug report response type
 * @type {DrugReportResponse}
 */
export type DrugReportResponse = PaginationResponse<any>;

/**
 * @description Report service
 * @type {ReportService}
 */
const ReportService = {
  /**
   * @description Get drug report
   * @param {Object} queryParams - Query parameters
   * @returns {Promise<DrugReportResponse>} Drug report response
   */
  getDrugReport: (queryParams: {
    pageIndex: number;
    pageSize: number;
    sorting?: ColumnSort[];
    columnFilters?: ColumnFilter[];
  }) => {
    return axiosInstance.get<DrugReportResponse>('/v1/reports/drug-report', {
      params: queryParams,
    });
  },

  /**
   * @description Download drug report
   * @param {Object} data - Data
   * @returns {Promise<any>} Drug report response
   */
  downloadDrugReport: (data: {
    sorting?: ColumnSort[];
    columnFilters: ColumnFilter[];
    columnVisibility: { [key: string]: boolean };
  }) => {
    return axiosInstance.post<any>('/v1/reports/drug-report/pdf', data, {
      headers: {
        Accept: '*/*',
      },
      responseType: 'blob',
    });
  },
};

export default ReportService;
